const { stripHTML } = require('./stripHTML.js');
const _ = require('lodash');

exports.createPressSlug = title => {
  const titleStripHTML = stripHTML(title);
  const postURL = 'press/' + _.kebabCase(titleStripHTML.replace(/[^a-zA-Z0-9\s-]/g, ''));
  return postURL;
};
